import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Button } from 'antd';
import 'antd/dist/antd.css'

import { FilePicker } from 'react-file-picker';

import { updateText } from '../actions';

class UploadButton extends Component {
  constructor(props) {
    super(props);
  }

  loadText(file, update) {
    let fileReader = new FileReader();
    fileReader.readAsText(file, 'UTF-8');
    fileReader.onload = function(fileLoadedEvent) {
      update(fileLoadedEvent.target.result);
    };
  }

  // input the object in which the text should be changed
  render() {
    return (
      <FilePicker
        extensions={this.props.extensions}
        onChange={file => {
          this.loadText(file, this.props.updateText);
        }}>
        <Button className="btn">Upload File</Button>
      </FilePicker>
    );
  }
}

UploadButton.propTypes = {
  extensions: PropTypes.array,
  updateText: PropTypes.func
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ updateText: updateText }, dispatch);
}

export default connect(
  null,
  mapDispatchToProps
)(UploadButton);



// WEBPACK FOOTER //
// ./src/containers/UploadButton.js